// Chatwoot live-chat widget integration (replaces the previous Intercom setup).

export const WEBSITE_TOKEN = "yxmoW5uqY4c1m79PyM9T1s7y";
export const BASE_URL = "https://app.chatwoot.com";

// Custom launcher element ID — our own floating button toggles the widget,
// so the default Chatwoot bubble stays hidden (see hideMessageBubble below).
export const CHATWOOT_LAUNCHER_ID = "chatwoot-custom-launcher";

let loaded = false;

// Injects the Chatwoot SDK. Must run before setUser; it initializes window.$chatwoot.
export const load = () => {
  if (typeof window === "undefined" || loaded) return;
  loaded = true;

  window.chatwootSettings = {
    position: "right",
    type: "standard",
    launcherTitle: "",
    hideMessageBubble: true, // we render our own launcher (ChatwootLauncher)
  };

  (function (d, t) {
    const g = d.createElement(t);
    const s = d.getElementsByTagName(t)[0];
    g.src = BASE_URL + "/packs/js/sdk.js";
    g.async = true;
    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      window.chatwootSDK.run({
        websiteToken: WEBSITE_TOKEN,
        baseUrl: BASE_URL,
      });
    };
  })(document, "script");
};

// Runs a callback once the widget is ready (or immediately if already ready).
const onReady = (cb) => {
  if (typeof window === "undefined") return;
  if (window.$chatwoot) {
    cb();
  } else {
    window.addEventListener("chatwoot:ready", cb, { once: true });
  }
};

// Identifies the logged-in user with verified identity (HMAC). The identifier
// and identifierHash are produced together by the backend so they always match.
export const setUser = ({ id, name, email, identifierHash }) => {
  onReady(() => {
    window.$chatwoot.setUser(id, {
      name,
      email,
      identifier_hash: identifierHash,
    });
  });
};

// Opens (or toggles) the chat window — wired to our custom launcher button.
export const toggle = (state = "open") => {
  onReady(() => window.$chatwoot.toggle(state));
};

// Clears the user session on logout.
export const reset = () => {
  if (typeof window !== "undefined" && window.$chatwoot) {
    window.$chatwoot.reset();
  }
};
